import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { st, Modal, MainView, Form, FormControl, FormSection, Button, CustomerDecorator } from "lib/index";
import { stateSelector, close, fetchCustomer, updateCustomer, submit, removeCustomer } from "./index";

@connect(
  (state) => ({
    opened: stateSelector(state).opened,
    customerId: stateSelector(state).customerId,
    fetchDone: stateSelector(state).customer.fetchDone,
    fetchLoading: stateSelector(state).customer.fetchLoading,
    fetchFailed: stateSelector(state).customer.fetchFailed,
    customer: stateSelector(state).form.model,
    errors: stateSelector(state).form.errors,
    valid: stateSelector(state).form.valid,
    submitLoading: stateSelector(state).form.submitLoading || stateSelector(state).removal.fetchLoading,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        close,
        fetchCustomer,
        updateCustomer,
        submit,
        removeCustomer,
      },
      dispatch
    )
)
export default class EditCustomerModal extends React.PureComponent {
  handleSubmit(event) {
    event.preventDefault();
    this.props.submit();
  }

  handlePropChange(prop, value) {
    const { customer, updateCustomer } = this.props;
    const nextCustomer = new CustomerDecorator({
      ...customer,
      [prop]: value,
    });
    updateCustomer(nextCustomer);
  }

  handleRemoveClick() {
    const { removeCustomer } = this.props;
    st.confirm({
      content: I18n.t("papp.customers.EditCustomerModal.remove_confirm_message"),
    }).then((yes) => yes && removeCustomer());
  }

  render() {
    const {
      opened,
      customerId,
      fetchLoading,
      fetchFailed,
      fetchDone,
      fetchCustomer,
      close,
      customer,
      valid,
      errors,
      validate,
      submit,
      submitLoading,
    } = this.props;
    return (
      opened && (
        <Modal closeIcon closeOnDimmerClick={false} open onClose={() => close()}>
          <Modal.Header>
            {customerId
              ? I18n.t("papp.customers.EditCustomerModal.existing_customer_title")
              : I18n.t("papp.customers.EditCustomerModal.new_customer_title")}
          </Modal.Header>
          <Modal.Content>
            <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetchCustomer} />
            {fetchDone && customer && (
              <Form onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
                <FormControl.InputFormGroup
                  {...FormControl.addProps(`customer.full_name`, { errors })}
                  value={customer.full_name}
                  onChange={this.handlePropChange.bind(this, "full_name")}
                  onBlur={validate}
                  label={I18n.humanAttributeName("customer", "full_name")}
                  required
                />

                <FormControl.InputFormGroup
                  {...FormControl.addProps(`customer.email`, { errors })}
                  value={customer.email}
                  onChange={this.handlePropChange.bind(this, "email")}
                  onBlur={validate}
                  label={I18n.humanAttributeName("customer", "email")}
                  type="email"
                />

                <FormControl.InputFormGroup
                  {...FormControl.addProps(`customer.phone_number`, { errors })}
                  value={customer.phone_number}
                  onChange={this.handlePropChange.bind(this, "phone_number")}
                  onBlur={validate}
                  label={I18n.humanAttributeName("customer", "phone_number")}
                  type="tel"
                />

                <FormControl.TextAreaFormGroup
                  {...FormControl.addProps(`customer.company_note`, { errors })}
                  value={customer.company_note}
                  onChange={this.handlePropChange.bind(this, "company_note")}
                  onBlur={validate}
                  label={I18n.humanAttributeName("customer", "company_note")}
                  autoHeight
                />

                <button type="submit" disabled={submitLoading} hidden />
              </Form>
            )}
          </Modal.Content>
          {fetchDone && customer && (
            <Modal.Actions>
              <Button as="a" floated="left" basic onClick={() => close()} content={I18n.t("papp.common.go_back")} />
              {!!customer.id && (
                <Button
                  as="a"
                  floated="left"
                  basic
                  negative
                  onClick={this.handleRemoveClick.bind(this)}
                  content={I18n.t("papp.common.remove")}
                />
              )}
              <Button
                as="a"
                primary
                onClick={submit}
                disabled={!valid || submitLoading}
                content={I18n.t("papp.common.save")}
              />
            </Modal.Actions>
          )}
        </Modal>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/customers/EditCustomerModal/EditCustomerModal.jsx